import axios from 'axios';
import jwt from 'jsonwebtoken';
import { getAuth } from 'firebase/auth';

// const baseUrl = "https://syncapi.home.co.th/api/v1"
const baseUrl = process.env.REACT_APP_API;
// console.log(process.env.REACT_APP_SOME);
const axiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 6000,
});

axiosInstance.interceptors.request.use(
  async function (config) {
    let accessToken = localStorage.getItem('access');

    if (accessToken) {
      if (parseInt(new Date().getTime() / 1000, 10) >= jwt.decode(accessToken).exp) {
        accessToken = await getAuth().currentUser.getIdToken();
        localStorage.setItem('access', accessToken);
      }
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  function (error) {
    // AuthService.logout();
    // window.location.href = '/login';
    // Do something with request error
    return Promise.reject(error);
  }
);

export default axiosInstance;
